/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Retention_Content_DescInputs */

const es_privacy_policy_retention_content_desc = /** @type {(inputs: Privacy_Policy_Retention_Content_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al desconectar un servicio, se inicia un periodo de gracia de 7 dias. Despues, todos los datos derivados se eliminan de forma segura.`)
};

const en_privacy_policy_retention_content_desc = /** @type {(inputs: Privacy_Policy_Retention_Content_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upon disconnecting a service, a 7-day grace period begins. After that, all derived data is securely deleted.`)
};

/**
* | output |
* | --- |
* | "Upon disconnecting a service, a 7-day grace period begins. After that, all derived data is securely deleted." |
*
* @param {Privacy_Policy_Retention_Content_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_retention_content_desc = /** @type {((inputs?: Privacy_Policy_Retention_Content_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Retention_Content_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_retention_content_desc(inputs)
	return en_privacy_policy_retention_content_desc(inputs)
});
export { privacy_policy_retention_content_desc as "privacy_policy.retention.content_desc" }